import i18n from 'i18next'
import {EXHIBITION} from '../../../locales/components/namespaces'

const getImageInsertionMessage = () => i18n.t(
    'Image upload, paste and drag-and-drop are disabled. Use Insert/edit image and enter an image URL.',
    {ns: EXHIBITION}
)

const notifyImageInsertionBlocked = (editor) => {
    editor.notificationManager.open({
        type: 'warning',
        text: getImageInsertionMessage(),
    })
}

export const imageOptions = {
    image_uploadtab: false,
    automatic_uploads: false,
    paste_data_images: false,
    images_upload_handler: (_blobInfo, _success, failure) => {
        failure(getImageInsertionMessage(), {remove: true})
    },
    setup: (editor) => {
        editor.on('PastePreProcess', (event) => {
            const pastedDocument = new DOMParser().parseFromString(event.content, 'text/html')
            const pastedImages = pastedDocument.querySelectorAll('img, picture')
            if (pastedImages.length) {
                pastedImages.forEach(image => image.remove())
                event.content = pastedDocument.body.innerHTML
                notifyImageInsertionBlocked(editor)
            }
        })
        editor.on('paste drop', (event) => {
            const transfer = event.clipboardData || event.dataTransfer
            if (!transfer) {
                return
            }

            const hasImageFile = Array.from(transfer.items || []).some(item => item.type.startsWith('image/'))
                || Array.from(transfer.files || []).some(file => file.type.startsWith('image/'))
            const droppedHtml = event.type === 'drop'
                ? transfer.getData('text/html') || transfer.getData('x-tinymce/html')
                : ''
            const hasDroppedImage = droppedHtml
                && new DOMParser().parseFromString(droppedHtml, 'text/html').querySelector('img, picture')

            if (hasImageFile || hasDroppedImage) {
                event.preventDefault()
                event.stopImmediatePropagation()
                notifyImageInsertionBlocked(editor)
            }
        }, true)
    },
}
